const GERMAN_COUNTRIES = new Set(['DE', 'AT', 'CH', 'LI']);
const ENGLISH_COUNTRIES = new Set(['GB', 'IE', 'US', 'CA', 'AU', 'NZ']);
export const getLanguageCodeForCountry = (countryCode) => {
    const code = countryCode.toUpperCase();
    if (GERMAN_COUNTRIES.has(code))
        return 'de';
    if (ENGLISH_COUNTRIES.has(code))
        return 'en';
    return 'nl';
};
